import { ApolloError, type ApolloQueryResult } from '@apollo/client';

import { type TOptional } from '@/types/common';

const checkResultForError = <R = unknown>(
  { error, errors }: ApolloQueryResult<R>,
  errorMessage?: string,
  extraInfo?: unknown,
): TOptional<ApolloError> => {
  if (error instanceof ApolloError) return error;
  if (errors?.length) return new ApolloError({ errorMessage, extraInfo, graphQLErrors: errors });
};

export default checkResultForError;
